import { useQuery } from '@tanstack/react-query';
import { listDedicatedIps } from '../services/admin';

// eslint-disable-next-line import/prefer-default-export
export const useListDedicatedIps = () => {
  return useQuery(['dedicated-ip'], listDedicatedIps);
};
